"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectors = exports.entityReducer = exports.entityAdapter = exports.addOne = exports.getMany = exports.getOne = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var map_keys_deep_lodash_1 = __importDefault(require("map-keys-deep-lodash"));
var normalizr_1 = require("normalizr");
var config_1 = __importDefault(require("../config"));
var createEntityReducer_1 = __importDefault(require("../createEntityReducer"));
var schema_1 = __importStar(require("./schema"));
/**
 * Get the details of an image.
 *
 * @param {string} inspectionId The ID of the inspection.
 * @param {string} imageId The ID of the image.
 * @param {GetOneImageOptions} [options] The optional query options.
 */
function getOne(inspectionId, imageId, options) {
    return __awaiter(this, void 0, void 0, function () {
        var params, axiosResponse;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    params = (0, map_keys_deep_lodash_1.default)(options, function (v, k) { return (0, lodash_1.snakeCase)(k); });
                    return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'get', url: "/inspections/".concat(inspectionId, "/images/").concat(imageId), params: (0, lodash_1.omitBy)(params, lodash_1.isNil) }))];
                case 1:
                    axiosResponse = _b.sent();
                    return [2 /*return*/, (__assign((_a = { axiosResponse: axiosResponse, inspectionId: inspectionId }, _a[schema_1.idAttribute] = imageId, _a), (0, normalizr_1.normalize)(axiosResponse.data, schema_1.default)))];
            }
        });
    });
}
exports.getOne = getOne;
/**
 * Get a page of images of an inspection.
 *
 * @param {string} inspectionId The id of the inspection.
 * @param {GetManyImagesOptions} [options] The query options.
 */
function getMany(inspectionId, options) {
    return __awaiter(this, void 0, void 0, function () {
        var params, axiosResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = (0, map_keys_deep_lodash_1.default)(options, function (v, k) { return (0, lodash_1.snakeCase)(k); });
                    return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'get', url: "/inspections/".concat(inspectionId, "/images"), params: (0, lodash_1.omitBy)(params, lodash_1.isNil) }))];
                case 1:
                    axiosResponse = _a.sent();
                    return [2 /*return*/, __assign({ axiosResponse: axiosResponse, inspectionId: inspectionId }, (0, normalizr_1.normalize)((0, map_keys_deep_lodash_1.default)(axiosResponse.data.data, function (v, k) { return (0, lodash_1.camelCase)(k); }), [schema_1.default]))];
            }
        });
    });
}
exports.getMany = getMany;
/**
 * Add an image to an inspection.
 *
 * @param {string} inspectionId The id of the inspeciton.
 * @param {CreatedImage} createImage The details of the image to add.
 */
function addOne(inspectionId, createImage) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosResponse, id, entity;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'post', url: "/inspections/".concat(inspectionId, "/images"), data: (0, map_keys_deep_lodash_1.default)(createImage, function (v, k) { return (0, lodash_1.snakeCase)(k); }) }))];
                case 1:
                    axiosResponse = _c.sent();
                    id = axiosResponse.data[schema_1.idAttribute];
                    entity = (_a = {},
                        _a[schema_1.idAttribute] = id,
                        _a.name = createImage.name,
                        _a);
                    return [2 /*return*/, __assign((_b = { axiosResponse: axiosResponse, inspectionId: inspectionId }, _b[schema_1.idAttribute] = id, _b), (0, normalizr_1.normalize)(entity, schema_1.default))];
            }
        });
    });
}
exports.addOne = addOne;
exports.entityAdapter = (0, toolkit_1.createEntityAdapter)({});
exports.entityReducer = (0, createEntityReducer_1.default)(schema_1.key, exports.entityAdapter);
exports.selectors = exports.entityAdapter.getSelectors(function (state) { return state[schema_1.key]; });
exports.default = (0, toolkit_1.createSlice)({
    name: schema_1.key,
    initialState: exports.entityAdapter.getInitialState({ entities: {}, ids: [] }),
    reducers: exports.entityReducer,
    extraReducers: function (builder) {
        builder.addCase('inspections/gotOne', function (state, action) {
            var entities = action.payload.entities;
            var images = entities[schema_1.key];
            if (!(0, lodash_1.isEmpty)(images)) {
                exports.entityAdapter.upsertMany(state, images);
            }
        }).addCase('inspections/gotMany', function (state, action) {
            var entities = action.payload.entities;
            var images = entities[schema_1.key];
            if (!(0, lodash_1.isEmpty)(images)) {
                exports.entityAdapter.upsertMany(state, images);
            }
        });
    },
});
//# sourceMappingURL=index.js.map